import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addKnowledgeBase,
  deleteKnowledgeBase,
  fetchKnowledgeBaseList,
  updateKnowledgeBase,
} from "../../apis/knowledgeBase";

export const fetchKnowledgeBaseData = createAsyncThunk(
  "knowledgeBase/fetchKnowledgeBase",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchKnowledgeBaseList();
      return data;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any;
      return !state.knowledgeBase.isDataFetched;
    },
  }
);

export const updateKnowledgeBaseData = createAsyncThunk(
  "knowledgeBase/updateKnowledgeBase",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        id: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      await updateKnowledgeBase(id, data);
      return { success: true, data };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteKnowledgeBaseData = createAsyncThunk(
  "knowledgeBase/deleteKnowledgeBase",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteKnowledgeBase(id);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);

export const addKnowledgeBaseData = createAsyncThunk(
  "knowledgeBase/addKnowledgeBase",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addKnowledgeBase(data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);
